import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const AUTH0_SERVER_URL = 'https://www.enlive.inc';

const Auth0Component = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const { loginWithRedirect } = useAuth0();

  const getOS = () => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("Win") !== -1) return "windows";
    if (userAgent.indexOf("Mac") !== -1) return "macos";
    if (userAgent.indexOf("Linux") !== -1) return "linux";
    return "unknown";
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    
    const handleLogin = () => {
      const os = getOS();
      window.location.href = `${AUTH0_SERVER_URL}/login?os=${os}`;
    };

    const handleCallback = () => {
        // Let the backend handle the full callback by redirecting to it
        // Pass the full query string (code, state) to the backend
        const params = window.location.search; // "?code=...&state=..."
        window.location.href = `${AUTH0_SERVER_URL}/callback${params}`;
    };

    const checkAuthStatus = async () => {
      try {
        const response = await fetch(`${AUTH0_SERVER_URL}/check-auth`, {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          setIsAuthenticated(data.authenticated);
          localStorage.setItem('isAuthenticated', data.authenticated.toString());
          
          console.log('[Auth0Component] Auth status checked:', data.authenticated);
          
        }
      } catch (error) {
        console.error('Error checking auth status:', error);
      }
    };

    if (pathname === '/login') {
      handleLogin();
    } else if (pathname === '/callback') {
      handleCallback();
    } else {
      checkAuthStatus();
    }
  }, [navigate, setIsAuthenticated, loginWithRedirect]);

  return <div style={{minHeight: "100vh"}}>Authenticating...</div>;
};

export default Auth0Component;